import { Box, Grid, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

export const SubscriptionPromoMessage = ({ bodyText, bodyTextAlt, subscriptionFee }) => (
  <Box marginBottom={3}>
    <Grid container justify="center">
      <Grid item>
        {subscriptionFee ? (
          <>
            <Typography variant="body1">{bodyText}</Typography>
            <Typography gutterBottom variant="body1">
              {bodyTextAlt}
            </Typography>
          </>
        ) : (
          <SkeletonLoadingSubscriptionText />
        )}
      </Grid>
    </Grid>
  </Box>
)

const SkeletonLoadingSubscriptionText = () => (
  <Box marginTop={3}>
    <Skeleton height={48} width={480} />
    <Skeleton height={48} width={320} />
  </Box>
)

export default SubscriptionPromoMessage
